<template>
  <div class="no-results-suggestions">
    <div class="h3 my-4 pb-4">Ci dispiace! Non ci sono risultati</div>
    <!-- SUGGESTIONS BY RADIUS -->
    <div
      class="content-panel panel"
      v-if="
        suggested_by_radius.departure.length ||
        suggested_by_radius.arrival.length ||
        suggested_by_radius.departure_arrival.length
      "
    >
      <h6 class="no-results-suggestions--heading">
        Vuoi volare da un aeroporto vicino? Scopri queste offerte.
      </h6>
      <div class="no-results-suggestions--flights">
        <b-row>
          <b-col
            md="6"
            class="m-auto"
            v-if="suggested_by_radius.departure.length"
          >
            <div class="no-results-suggestions--title">Parti da:</div>
            <div
              class="no-results-suggestions--flight"
              v-for="(suggestion, index) in suggested_by_radius.departure"
              v-bind:key="'or_dep_' + index + _uid"
            >
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary semibold">
                  {{ suggestion.label_departure }}
                  ({{ suggestion.iata_code_departure }})
                </div>
                <div>
                  A partire da
                  <span class="text-primary semibold"
                    >{{
                      apply_markup_to_number(
                        suggestion.flight_offer,
                        suggestion.min_price,
                      )
                    }}
                    {{ suggestion.currencySymbol || suggestion.currency }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <vb-button
                  :vb_options="{ size: 'md', variant: 'info' }"
                  @click="
                    search_by_suggestion({
                      iata_code_departure: suggestion.iata_code_departure,
                      label_departure: suggestion.label_departure,
                    })
                  "
                >
                  Scopri!
                </vb-button>
              </div>
            </div>
          </b-col>
          <b-col
            md="6"
            class="m-auto"
            v-if="suggested_by_radius.arrival.length"
          >
            <div class="no-results-suggestions--title">Arriva a:</div>
            <div
              class="no-results-suggestions--flight"
              v-for="(suggestion, index) in suggested_by_radius.arrival"
              v-bind:key="'or_arr_' + index + _uid"
            >
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary semibold">
                  {{ suggestion.label_arrival }}
                  ({{ suggestion.iata_code_arrival }})
                </div>
                <div class="no-results-suggestions--price">
                  A partire da
                  <span
                    >{{ suggestion.min_price }}
                    {{ suggestion.currencySymbol || suggestion.currency }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <vb-button
                  :vb_options="{ size: 'md', variant: 'info' }"
                  @click="
                    search_by_suggestion({
                      iata_code_arrival: suggestion.iata_code_arrival,
                      label_arrival: suggestion.label_arrival,
                    })
                  "
                >
                  Scopri!
                </vb-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="suggested_by_radius.departure_arrival.length">
          <!-- il copy "oppure" ha senso solo se sopra ci sono altre offerte -->
          <div
            v-if="
              suggested_by_radius.departure.length > 0 ||
              suggested_by_radius.arrival.length > 0
            "
            class="no-results-suggestions--title"
          >
            Oppure:
          </div>

          <b-row>
            <b-col
              md="6"
              v-for="(
                suggestion, index
              ) in suggested_by_radius.departure_arrival"
              v-bind:key="'or_arr_' + index + _uid"
            >
              <div class="no-results-suggestions--flight">
                <div class="no-results-suggestions--flight--left">
                  <div class="text-tertiary">
                    <div>
                      Parti da:
                      <span class="semibold"
                        >{{ suggestion.label_departure }} ({{
                          suggestion.iata_code_departure
                        }})</span
                      >
                    </div>
                    <div>
                      Arriva a:
                      <span class="semibold"
                        >{{ suggestion.label_arrival }} ({{
                          suggestion.iata_code_arrival
                        }})</span
                      >
                    </div>
                  </div>
                  <div class="no-results-suggestions--price">
                    A partire da
                    <span
                      >{{ suggestion.min_price }}
                      {{
                        suggestion.currencySymbol || suggestion.currency
                      }}</span
                    >
                  </div>
                </div>
                <div class="no-results-suggestions--flight--right">
                  <vb-button
                    :vb_options="{ size: 'md', variant: 'info' }"
                    @click="
                      search_by_suggestion({
                        iata_code_arrival: suggestion.iata_code_arrival,
                        iata_code_departure: suggestion.iata_code_departure,
                        label_departure: suggestion.label_departure,
                        label_arrival: suggestion.label_arrival,
                      })
                    "
                  >
                    Scopri!
                  </vb-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- SUGGESTIONS BY TIME WINDOW / LIST -->
    <div
      class="content-panel panel"
      v-if="suggested_by_time_window.suggested.length"
    >
      <h6 class="no-results-suggestions--heading">Valuta altre date!</h6>
      <div class="no-results-suggestions--flights">
        <b-row>
          <b-col
            md="6"
            v-for="(suggestion, index) in suggested_by_time_window.suggested"
            v-bind:key="'tf_dep_' + index + _uid"
          >
            <div class="no-results-suggestions--flight">
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary semibold">
                  {{
                    parse_flight_offers_date(suggestion.in).friendly_date_short
                      | lowercase
                  }}
                  <span v-if="return_flight">
                    -
                    {{
                      parse_flight_offers_date(suggestion.out)
                        .friendly_date_short | lowercase
                    }}</span
                  >
                </div>
                <div class="no-results-suggestions--price">
                  A partire da
                  <span
                    >{{
                      apply_markup_to_number(
                        suggestion.flight_offer,
                        suggestion.min_price,
                      )
                    }}
                    {{ suggestion.currencySymbol || suggestion.currency }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <vb-button
                  :vb_options="{ size: 'md', variant: 'info' }"
                  @click="
                    search_by_suggestion({
                      in: suggestion.in,
                      out: suggestion.out,
                    })
                  "
                >
                  Scopri!
                </vb-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { apply_markup_to_number } from "@liveflight/utilities/price";
import { parse_flight_offers_date } from "@liveflight/utilities/dates";
import {
  endpoint_label,
  update_origin_destination_by_index,
} from "@liveflight/utilities/origin-destination";

export default {
  name: "no-results-suggestions",
  computed: {
    suggestions() {
      return this.$store.state.liveflight.suggestions;
    },
    suggestions_by_radius() {
      const { by_radius = [] } = this.suggestions || {};
      return Array.isArray(by_radius) ? by_radius : [];
    },
    suggestions_by_time_window() {
      const { by_time_window = [] } = this.suggestions || {};
      return Array.isArray(by_time_window) ? by_time_window : [];
    },
    return_flight: {
      get() {
        return this.$store.state.liveflight.return_flight;
      },
      set(value) {
        this.$store.commit("liveflight/return_flight", value);
      },
    },
    origin_destinations: {
      get() {
        return this.$store.state.liveflight.origin_destinations;
      },
      set(value) {
        this.$store.commit("liveflight/origin_destinations", value);
      },
    },
    departure_airport() {
      const { departure = {} } = this.origin_destinations[0] || {};
      return departure.iata_code || "";
    },
    arrival_airport() {
      const { arrival = {} } = this.origin_destinations[0] || {};
      return arrival.iata_code || "";
    },
  },
  data() {
    return {
      loading: true,
      dates_in: [],
      dates_out: [],
      grid_items: [],
      suggested_by_time_window: {
        suggested: [],
      },
      suggested_by_radius: {
        departure: [],
        arrival: [],
        departure_arrival: [],
      },
    };
  },
  created() {
    this.parse_flight_offers_date = parse_flight_offers_date;
    this.apply_markup_to_number = apply_markup_to_number;
  },
  mounted() {
    this.get_suggested_by_time_window_airports();
    this.get_suggested_by_radius_airports();
  },
  methods: {
    // ─── Normalized-offer helpers ───────────────────────────────────────
    date_pair(offer) {
      const { firstDeparture = {}, lastDeparture = {}, oneWay } = offer || {};
      const date_in = firstDeparture.at || "";
      const date_out =
        this.return_flight && !oneWay ? lastDeparture.at || "" : "";
      return { date_in, date_out, key: `${date_in}-${date_out}` };
    },
    endpoints(offer) {
      const { firstDeparture = {}, lastArrival = {} } = offer || {};
      return {
        dep_code: firstDeparture.iataCode || "",
        arr_code: lastArrival.iataCode || "",
        dep_label: endpoint_label(firstDeparture),
        arr_label: endpoint_label(lastArrival),
      };
    },
    cheapest_with(offers, predicate) {
      return offers
        .filter(predicate)
        .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];
    },

    // ─── Derived suggestions ────────────────────────────────────────────
    get_suggested_by_time_window_airports() {
      const offers = this.suggestions_by_time_window;
      const suggested_flight_offers = [];

      offers.forEach((offer) => {
        const { date_in, date_out, key } = this.date_pair(offer);
        if (suggested_flight_offers.some((s) => `${s.in}-${s.out}` === key)) {
          return;
        }
        // trovo il prezzo minore per quella coppia di date
        const min_price = this.cheapest_with(
          offers,
          (other) => this.date_pair(other).key === key,
        );

        suggested_flight_offers.push({
          in: date_in,
          out: date_out,
          min_price: min_price.price.grandTotal,
          currency: min_price.price.currency,
          currencySymbol: min_price.price.currencySymbol,
          flight_offer: min_price,
        });
      });

      suggested_flight_offers.sort((a, b) => new Date(a.in) - new Date(b.in));

      this.suggested_by_time_window = {
        suggested: suggested_flight_offers,
      };
    },
    get_suggested_by_radius_airports() {
      const offers = this.suggestions_by_radius;
      const departure = [];
      const arrival = [];
      const departure_arrival = [];

      offers.forEach((offer) => {
        const { dep_code, arr_code, dep_label, arr_label } =
          this.endpoints(offer);

        // aeroporti con partenza diversa da quella della ricerca ma stesso arrivo
        if (
          dep_code !== this.departure_airport &&
          arr_code === this.arrival_airport &&
          !departure.some((s) => s.iata_code_departure === dep_code)
        ) {
          // calcolo il prezzo minore per offerte suggerite che abbiano questo aeroporto di partenza
          const min_price = this.cheapest_with(
            offers,
            (other) => this.endpoints(other).dep_code === dep_code,
          );
          // tiro fuori tre chiavi per comodità, ma metto anche la flight_offer intera per gestire il click del pulsante
          departure.push({
            iata_code_departure: dep_code,
            label_departure: dep_label,
            min_price: min_price.price.grandTotal,
            currency: min_price.price.currency,
            currencySymbol: min_price.price.currencySymbol,
            flight_offer: min_price,
          });
        }

        // aeroporti con stessa partenza di quella della ricerca ma con arrivo diverso
        if (
          dep_code === this.departure_airport &&
          arr_code !== this.arrival_airport &&
          !arrival.some((s) => s.iata_code_arrival === arr_code)
        ) {
          const min_price = this.cheapest_with(
            offers,
            (other) => this.endpoints(other).arr_code === arr_code,
          );
          arrival.push({
            iata_code_arrival: arr_code,
            label_arrival: arr_label,
            min_price: min_price.price.grandTotal,
            currency: min_price.price.currency,
            currencySymbol: min_price.price.currencySymbol,
            flight_offer: min_price,
          });
        }

        // aeroporti con diversa partenza e diverso arrivo rispetto a quelli della ricerca
        if (
          dep_code !== this.departure_airport &&
          arr_code !== this.arrival_airport &&
          !departure_arrival.some(
            (s) =>
              s.iata_code_departure === dep_code &&
              s.iata_code_arrival === arr_code,
          )
        ) {
          const min_price = this.cheapest_with(offers, (other) => {
            const e = this.endpoints(other);
            return e.dep_code === dep_code && e.arr_code === arr_code;
          });
          departure_arrival.push({
            iata_code_departure: dep_code,
            iata_code_arrival: arr_code,
            label_departure: dep_label,
            label_arrival: arr_label,
            min_price: min_price.price.grandTotal,
            currency: min_price.price.currency,
            currencySymbol: min_price.price.currencySymbol,
            flight_offer: min_price,
          });
        }
      });

      this.suggested_by_radius = {
        departure,
        arrival,
        departure_arrival,
      };
    },
    search_by_suggestion(suggestion) {
      const changes = {};

      if (suggestion.iata_code_departure) {
        changes.departure = {
          iata_code: suggestion.iata_code_departure,
          label: suggestion.label_departure || suggestion.iata_code_departure,
        };
      }

      if (suggestion.iata_code_arrival) {
        changes.arrival = {
          iata_code: suggestion.iata_code_arrival,
          label: suggestion.label_arrival || suggestion.iata_code_arrival,
        };
      }

      if (suggestion.in) {
        changes.date = suggestion.in.split("T")[0];
      }

      const updated = update_origin_destination_by_index(
        this.origin_destinations,
        0,
        changes,
        this.return_flight,
      );

      if (suggestion.out && updated[1]) {
        updated[1] = { ...updated[1], date: suggestion.out.split("T")[0] };
      }

      this.$store.commit("liveflight/origin_destinations", updated);
      window.eventBus.$emit("trigger-search-by-suggestion");
    },
  },
};
</script>

<style lang="scss">
.no-results-suggestions {
  text-align: center;
  margin-bottom: $grid-gutter-width;
  .panel {
    padding: $grid-gutter-width $grid-gutter-width;
    margin-bottom: $grid-gutter-width !important;
  }
  &--heading {
    @extend .h1 !optional;
    margin-bottom: $grid-gutter-width;
    font-weight: $vb-font-weight-semibold;
  }
  &--title {
    text-align: left;
    @include font-primary-regular;
    margin-top: 16px;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  &--flight {
    width: 100%;
    display: flex;
    margin-bottom: 4px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid $light-gray;
    margin-bottom: 16px;
    padding-bottom: 16px;
    &--left {
      flex: 1;
      text-align: left;
      padding-right: 20px;
    }
    &--right {
      text-align: right;
    }
  }
  .flight-offer {
    &--carriers {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      & > * {
        margin: 2px 3px;
      }
    }
    &--carrier {
      @extend .carrier-icon !optional;
    }
  }
  &--price {
    span {
      color: var(--primary);
      @include font-primary-bold;
    }
  }
}
</style>
